<template>
  <div class="groupContent clearfix">
    <div class="jiazaiBox" v-if="showLoading">
      <div class="spinner-border text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div v-if="!showLoading" class="searchBox">
      <div class="info">
        <div class="aa">
          <h4>
            <b>{{info.title}}</b>
          </h4>
          <p class="content">{{info.tagline}}</p>
        </div>
        <div v-if='info.priceType==="1"' class="bb text-danger">
          ￥{{price}}
        </div>
        <div v-if='info.priceType==="2"' class="bb text-danger">
          ￥{{priceCalculate}}
        </div>
      </div>
      <div v-if="info.content" class="text-primary">说明：{{info.content}}</div>
      <hr style="border-color: rgba(0,0,0,0.06);">
      <h6 v-if="info.countObj.must!==0" class="mb-3">
        <i class="iconfont icon-jia"></i> 必选项<span class="float-right">池内{{mustCheckArr.length}}个产品，必选{{info.countObj.must}}个产品</span>
      </h6>

      <div class="alert alert-secondary text-center content" v-if="info.countObj.must*1!==0 && mustCheckArr.length===0">
        <br>
        <br>
        <div>— 未发现选择项，请联系管理员 —</div>
        <br>
        <br>
      </div>

      <div v-if="info.countObj.must*1!==0 && mustCheckArr.length!==0" class="mustBox mb-4">
        <div class="lBox">
          <div class="shaixuanBox">
            <div class="box">
              <input v-model="mustKeywordVal" type="text" class="form-control" placeholder="产品名称">
            </div>
<!--            <div class="box">-->
<!--              <multiselect v-model="mustPinpaiVal" :hideSelected="false" :options="mustPinpaiArr" :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="品牌" label="name" track-by="id">-->
<!--                <template slot="selection" slot-scope="{ values, search, isOpen }"></template>-->
<!--              </multiselect>-->
<!--            </div>-->
          </div>
          <div class="bodyBox mb-0">
            <ul>
              <li v-show="app.isShow" @click="addMustValArr(app.id)" :class="{no:!app.isCheck,yes:app.isCheck}" v-for="(app,index) in mustCheckArr" :key="index">
                <i v-if="!app.isCheck" class="iconfont icon-square"></i><i v-if="app.isCheck" class="iconfont icon-squarecheckfill"></i>
                {{app.name}}
              </li>
            </ul>
          </div>
        </div>
        <div class="cBox">
          <i class="iconfont icon-qianwang"></i>
        </div>
        <div class="rBox">
<!--          <div class="shaixuanBox text-right">-->
<!--            {{mustCheckValArr.length}} / {{info.countObj.must}}-->
<!--          </div>-->
          <div class="bodyBox alert alert-success mb-0">
            <ul>
              <li @click="addMustValArr(app.id)" v-for="(app,index) in mustCheckValArr" :key="index"><i class="iconfont icon-squarecheckfill"></i> {{app.name}}</li>
            </ul>
            <p v-if="mustCheckValArr.length===0" class="text-center content mt-4">暂未选择</p>
          </div>
        </div>
      </div>
      <h6 v-if="info.countObj.zengsong!==0" class="mb-3">
        <i class="iconfont icon-jia"></i>  赠送池<span class="float-right">池内{{zengsongCheckArr.length}}个产品，必选{{info.countObj.zengsong}}个产品</span>
      </h6>
      <div class="alert alert-secondary text-center content" v-if="info.countObj.zengsong*1!==0 && zengsongCheckArr.length===0">
        <br>
        <br>
        <div>— 未发现选择项，请联系管理员 —</div>
        <br>
        <br>
      </div>
      <div v-if="info.countObj.zengsong!==0" class="mustBox mb-4">
        <div class="lBox">
          <div class="shaixuanBox">
            <div class="box">
              <input style="height: 41px;" v-model="zengsongKeywordVal" type="text" class="form-control" placeholder="产品名称">
            </div>
            <div class="box">
              <multiselect v-model="zengsongPinpaiVal" :hideSelected="false" :options="mustPinpaiArr" :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="品牌" label="name" track-by="id">
                <template slot="selection" slot-scope="{ values, search, isOpen }"></template>
              </multiselect>
            </div>
          </div>
          <div class="bodyBox mb-0">
            <ul>
              <li v-if="app.isShow" @click="addZengsongValArr(app.id)" :class="{no:!app.isCheck,yes:app.isCheck}" v-for="(app,index) in zengsongCheckArr" :key="index">
                <i v-if="!app.isCheck" class="iconfont icon-square"></i><i v-if="app.isCheck" class="iconfont icon-squarecheckfill"></i>
                {{app.name}}
              </li>
            </ul>
          </div>
        </div>
        <div class="cBox">
          <i class="iconfont icon-qianwang"></i>
        </div>
        <div class="rBox">
<!--          <div class="shaixuanBox text-right">-->
<!--            {{zengsongCheckValArr.length}} / {{info.countObj.zengsong}}-->
<!--          </div>-->
          <div class="bodyBox alert alert-success mb-0">
            <ul>
              <li @click="addZengsongValArr(app.id)" v-for="(app,index) in zengsongCheckValArr" :key="index"><i class="iconfont icon-squarecheckfill"></i> {{app.name}}</li>
            </ul>
            <p v-if="zengsongCheckValArr.length===0" class="text-center content mt-4">暂未选择</p>
          </div>
        </div>
      </div>
      <div class="btnBox clearfix">
        <div class="aa">
          <img src="/static/images/aliPay.svg">
          <img src="/static/images/wechatPay.svg">
        </div>
        <div class="bb">
          <button @click="purchaseFun" type="button" class="btn btn-primary">立即下单</button>
        </div>
      </div>
    </div>
    <ui-pay :parms="parms" v-if="purchaseBox" :closePurchaseBox="closePurchaseBox"></ui-pay>
  </div>
</template>

<script>
import resultcommons from '../../util/resultcommons';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
// import { EventBus } from '@/util/eventBus';
import generalMix from '@/util/mix/general';
import uiPay from '@/components/common/pay';
import commons from '../../util/commons';

export default {
  name: 'groupContent',
  props:['parameter'],
  mixins: [generalMix],
  data () {
    return {
      purchaseBox: false,
      parms:{},
      showLoading:true,
      id:0,
      // 详情
      info:null,
      price: 0,
      // 必选组
      mustKeywordVal:'',
      mustPinpaiVal: null,
      mustPinpaiArr: [],
      mustCheckArr:[],
      mustCheckValArr:[],
      // 赠送组
      zengsongKeywordVal:'',
      zengsongPinpaiVal: null,
      zengsongPinpaiArr: [],
      zengsongCheckArr:[],
      zengsongCheckValArr:[]
    }
  },
  watch:{
    mustKeywordVal(newVal, oldVal) {
      this.mustFilter();
    },
    mustPinpaiVal(newVal, oldVal) {
      this.mustFilter();
    },
    zengsongKeywordVal(newVal, oldVal) {
      this.zengsongFilter();
    },
    zengsongPinpaiVal(newVal, oldVal) {
      this.zengsongFilter();
    }
  },
  computed: {
    priceCalculate() {
      let money = 0;
      this.mustCheckValArr.forEach(app=>{
        money = commons.accAddNumber(money,app.price);
      });
      return money;
    }
  },
  methods:{
    // 筛选动作
    mustFilter() {
      // eslint-disable-next-line no-unused-vars
      var pinpaiBool;
      // eslint-disable-next-line no-unused-vars
      var keywordBool;
      this.mustCheckArr.forEach(app=>{
        pinpaiBool = true;
        keywordBool = true;
        if(!this.mustPinpaiVal && !this.mustKeywordVal.trim()){
          app.isShow = true;
        }else{
          if(this.mustPinpaiVal){
            // 如果属于筛选的品牌
            if((app.brand_id * 1) === (this.mustPinpaiVal.id * 1)){
              pinpaiBool = true;
            }else{
              pinpaiBool = false;
            }
          }
          if(this.mustKeywordVal.trim()){
            if(app.name.includes(this.mustKeywordVal.trim())){
              keywordBool = true;
            }else{
              keywordBool = false;
            }
          }
          // 判断
          if(this.mustPinpaiVal && this.mustKeywordVal.trim()){
            app.isShow = !!(pinpaiBool && keywordBool);
          }
          if(this.mustPinpaiVal && !this.mustKeywordVal.trim()){
            if(pinpaiBool){
              app.isShow = true;
            }else{
              app.isShow = false;
            }
          }
          if(!this.mustPinpaiVal && this.mustKeywordVal.trim()){
            if(keywordBool){
              app.isShow = true;
            }else{
              app.isShow = false;
            }
          }
        }
      })
    },
    zengsongFilter() {
      // eslint-disable-next-line no-unused-vars
      var pinpaiBool;
      // eslint-disable-next-line no-unused-vars
      var keywordBool;
      this.zengsongCheckArr.forEach(app=>{
        pinpaiBool = true;
        keywordBool = true;
        if(!this.zengsongPinpaiVal && !this.zengsongKeywordVal.trim()){
          app.isShow = true;
        }else{
          if(this.zengsongPinpaiVal){
            // 如果属于筛选的品牌
            if((app.brand_id * 1) === (this.zengsongPinpaiVal.id * 1)){
              pinpaiBool = true;
            }else{
              pinpaiBool = false;
            }
          }
          if(this.zengsongKeywordVal.trim()){
            if(app.name.includes(this.zengsongKeywordVal.trim())){
              keywordBool = true;
            }else{
              keywordBool = false;
            }
          }
          // 判断
          if(this.zengsongPinpaiVal && this.zengsongKeywordVal.trim()){
            app.isShow = !!(pinpaiBool && keywordBool);
          }
          if(this.zengsongPinpaiVal && !this.zengsongKeywordVal.trim()){
            if(pinpaiBool){
              app.isShow = true;
            }else{
              app.isShow = false;
            }
          }
          if(!this.zengsongPinpaiVal && this.zengsongKeywordVal.trim()){
            if(keywordBool){
              app.isShow = true;
            }else{
              app.isShow = false;
            }
          }
        }
      })
    },
    // 选择必选项
    addMustValArr(id) {
      // 是否已经存在了
      const repeatBool = this.mustCheckValArr.find(app => app.id === id);
      // 如果不存在则追加
      if (!repeatBool) {
        if(this.mustCheckValArr.length < this.info.countObj.must){
          const info = this.mustCheckArr.find(app => app.id === id);
          info.isCheck = true;
          const arr = {
            name: info.name,
            id: info.id,
            price: info.price
          };
          this.mustCheckValArr.unshift(arr);
        }else{
          this.$message.showMsgBox({
            type: 'warning',
            content: '超出上限'
          });
        }
      } else {
        // 存在则剔除
        this.mustCheckValArr = this.mustCheckValArr.filter(app => app.id !== id);
        const info = this.mustCheckArr.find(app => app.id === id);
        info.isCheck = false;
      }
    },
    addZengsongValArr(id) {
      // 是否已经存在了
      const repeatBool = this.zengsongCheckValArr.find(app => app.id === id);
      console.log(repeatBool);
      // 如果不存在则追加
      if (!repeatBool) {
        if(this.zengsongCheckValArr.length < this.info.countObj.zengsong){
          const info = this.zengsongCheckArr.find(app => app.id === id);
          info.isCheck = true;
          const arr = {
            name: info.name,
            id: info.id,
            price: info.price
          };
          this.zengsongCheckValArr.unshift(arr);
        }else{
          this.$message.showMsgBox({
            type: 'warning',
            content: '超出上限'
          });
        }
      } else {
        // 存在则剔除
        this.zengsongCheckValArr = this.zengsongCheckValArr.filter(app => app.id !== id);
        const info = this.zengsongCheckArr.find(app => app.id === id);
        info.isCheck = false;
      }
    },
    // 获取分类导航
    apiGoodsnav() {
      return resultcommons.apiGoodsnav(this, {}).then((ob) => {
        if(ob.state === 200){
          this.mustPinpaiArr = ob.data.pinpaiArr;
          this.zengsongPinpaiArr = ob.data.pinpaiArr;
        }else{
          this.$message.showMsgBox({
            type: 'warning',
            content: ob.message
          });
        }
        this.isLeixing = true;
      });
    },
    // 显示详情
    closePurchaseBox() {
      this.purchaseBox = false;
    },
    purchaseFun() {
      // 判断是否选择完
      if((this.info.countObj.must * 1) !== this.mustCheckValArr.length || (this.info.countObj.zengsong * 1) !== this.zengsongCheckValArr.length){
        this.$message.showMsgBox({
          type: 'warning',
          content: '请将组合选择完整'
        });
      }else{
        const parms = {};
        // 获取价格 获取所选的产品
        if(this.info.priceType === '1'){
          parms.price = this.price;
        }else{
          parms.price = this.priceCalculate;
        }
        parms.id = this.info.id;
        parms.type = 'group';
        // 选择的内容
        parms.mustCheckArr = this.mustCheckValArr;
        parms.zengsongCheckArr = this.zengsongCheckValArr;
        parms.title = this.info.title;
        parms.totalPrice = parms.price;
        this.parms = parms;
        this.purchaseBox = true;
      }
    }
    // 显示详情
    // addGoods(goodsID) {
    //   if(this.checkGoodsArr.includes(goodsID)){
    //     this.checkGoodsArr = this.checkGoodsArr.filter(e => e !== goodsID)
    //   }else{
    //     if(this.checkGoodsArr.length < this.info.countObj.select){
    //       this.checkGoodsArr = [...this.checkGoodsArr, goodsID];
    //     }else{
    //       this.$message.showMsgBox({
    //         type: 'warning',
    //         content: '不能再选择了'
    //       });
    //     }
    //   }
    // },
    // // 获取单个商品的详情
    // apiGoodsinfo(token){
    //   this.showLoading = true;
    //   resultcommons.apiGoodsinfo(this,{token:token}).then(app=>{
    //     if(app.state === 200){
    //       this.showLoading = false;
    //       this.details = app.data.details;
    //     }else{
    //       this.$message.showMsgBox({
    //         type: 'warning',
    //         content: app.message
    //       });
    //     }
    //   });
    // },
    // showGoodsGun(goodsID){
    //   this.showID = goodsID;
    //   this.apiGoodsinfo(goodsID);
    // }
  },
  components: {
    Multiselect,
    'ui-pay':uiPay
  },
  created() {
    this.apiGoodsnav();
    this.id = this.parameter.token;
    // 标签
    // EventBus.$emit('globalLoadingFun', { bool: true,loading:true });
    resultcommons.apiGroupgoodsinfo(this,{token:this.id}).then(app=>{
      if(app.state === 200){
        this.info = app.data.info;
        if(this.info.priceType === '1'){
          this.price = this.info.total_amount;
        }else{
          this.price = '选择计算';
        }
        app.data.mustArr.forEach(app=>{
          app.isShow = true;
        });
        this.mustCheckArr = app.data.mustArr;
        app.data.zengsongArr.forEach(app=>{
          app.isShow = true;
        });
        this.zengsongCheckArr = app.data.zengsongArr;
        this.showLoading = false;
      }else{
        this.$message.showMsgBox({
          type: 'warning',
          content: app.message
        });
      }
      // console.log(app);
      // EventBus.$emit('globalLoadingFun', { bool: false,loading:false });
    });
  },
  mounted() {
  },
  destroyed() {
  }
}
</script>

<style scoped lang='less'>

.groupContent {
  padding: 30px;
  padding-right: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  width: 60vw;
  height: 100%;
  overflow-y: auto;
  background: #F5F5F7;
  color: #000000;
  div.jiazaiBox{
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    //box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    //background: #373737;
    min-height: 30vh;
    .spinner-border{
      width: 3rem;
      height: 3rem;
    }
    &.threeBox{
      min-height: 50vh;
    }
  }
  div.searchBox{
    div.info{
      display: flex;
      div.aa{
        flex: 1;
      }
      div.bb{
        font-size: 26px;
        font-weight: bold;
      }
    }
    div.btnBox{
      display: flex;
      div.aa{
        img{
          height: 35px;
          width: 35px;
          margin-right: 5px;
          padding: 5px;
          border-radius: 5px;
          border: 1px solid #E8E8E8;
          background: #FFFFFF;
          &:last-child{
            margin-right: 0;
          }
        }
      }
      div.bb{
        flex: 1;
        flex-direction: column;
        display: flex;
        align-items: end;
        div{
          font-weight: bold;
        }
      }
    }
    div.mustBox{
      display: flex;
      height: 300px;
      background: #FFFFFF;
      border: 1px solid #CED4DA;
      border-radius: 5px;
      div.lBox{
        flex: 1;
        /*background: #FFFFFF;*/
        border-radius: 5px;
        display: flex;
        flex-direction: column;
        padding: 10px;
        /*border: 1px solid #E8E8E8;*/
        div.shaixuanBox{
          display: flex;
          div.box{
            flex: 1;
          }
        }
        div.bodyBox{
          flex: 1;
          overflow-y: auto;
          padding: 5px;
          border: 1px solid #CED4DA;
          margin-top: 10px;
          margin-bottom: 10px;
          background: #FFFFFF;
          border-radius: 5px;
          li{
            cursor: pointer;
            padding-left: 25px;
            position: relative;
            i{
              position: absolute;
              left: 2px;
              top: 1px;
            }
            &:hover{
              color: #2A37FE;
            }
            &.yes{
              color: #28A745;
              &:hover{
                color: #D73038;
              }
            }
            &.no{
              &:hover{
                color: #28A745;
              }
            }
          }
        }
        div.footerBox{

        }
      }
      div.cBox{
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 10px;
        margin-right: 10px;
        i{
          font-size: 20px;
        }
      }
      div.rBox{
        flex: 1;
        display: flex;
        flex-direction: column;
        padding: 10px;
        div.shaixuanBox{
        }
        div.bodyBox{
          flex: 1;
          overflow-y: auto;
          padding: 5px;
          margin-bottom: 10px;
          /*background: #FFFFFF;*/
          /*border: 1px solid #CED4DA;*/
          border-radius: 5px;
          li{
            cursor: pointer;
            padding-left: 25px;
            position: relative;
            color: #28A745;
            i{
              position: absolute;
              left: 2px;
              top: 1px;
            }
            &:hover{
              color: #D73038;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 1200px) {
  .groupContent{
    width: 70vw;
    div.daohangBox{
      ul{
        text-align: center;
      }
    }
  }
}

@media (max-width: 992px) {
  .groupContent{
    width: 90vw;
  }
}

@media (max-width: 776px) {
  .groupContent{
    width: 90vw;
    padding: 10px;
    div.searchBox{
      padding: 20px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/group/Content.vue